<opac-table-cell>
  <span>
    <ng-content></ng-content>
  </span>
</opac-table-cell>
